<template>
  <panel title="在产分布" class="mgb10">
    <template v-slot:right>
      <router-link
        :to="{ name: 'mesWorkOrders', query: { initFilter: 'inProduction' } }"
        class="small-link"
      >
        在产总量 {{ allQty }} 件
      </router-link>
    </template>
    <vxe-table
      :data="records"
      border
      size="small"
      :loading="loading"
      class="border-inner-top"
      auto-resize
      highlight-hover-row
      :scroll-y="{ enabled: false }"
    >
      <vxe-table-column field="phaseName" title="工序"></vxe-table-column>
      <vxe-table-column field="unStartQty" title="未开始"></vxe-table-column>
      <vxe-table-column field="startQty" title="生产中"></vxe-table-column>
      <vxe-table-column field="finishQty" title="已完成"></vxe-table-column>
    </vxe-table>
  </panel>
</template>

<script>
import axios from "axios";
import OrderMes from "@/api/orderMes.js";
import WorkOrder from "@/api/workOrder.js";

export default {
  data() {
    return {
      loading: false,
      allQty: 0,
      records: [],
    };
  },
  created() {
    const self = this;
    self.loading = true;
    axios
      .all([
        OrderMes.processingPhaseCount(),
        WorkOrder.processingProductCount(),
      ])
      .then(
        axios.spread(function (counts, qty) {
          if (counts.status === 200) {
            self.records = counts.data;
          } else {
            self.sysError();
          }
          if (qty.status === 200) {
            self.allQty = qty.data;
          } else {
            self.sysError();
          }
          self.loading = false;
        })
      );
  },
};
</script>